import { Component, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

// Cliente della proposta richiesto in App: la proposta prosegue, la codifica arriva dopo
@Component({
  selector: 'ord-new-customer-request-banner',
  imports: [MatButtonModule],
  template: `
    @if (visible()) {
      <div class="request-banner">
        <i class="fa-solid fa-user-check request-banner-icon" aria-hidden="true"></i>
        <div class="request-banner-text">
          <span class="body-medium-emphasized request-banner-title">Hai completato il processo di richiesta codifica del nuovo cliente</span>
          <span class="body-medium">Puoi completare la proposta d'ordine, la codifica avverrà dopo l'approvazione.</span>
        </div>
        <button matIconButton type="button" class="request-banner-close" aria-label="Chiudi avviso" (click)="visible.set(false)">
          <i class="fa-regular fa-xmark" aria-hidden="true"></i>
        </button>
      </div>
    }
  `,
  styles: `
    :host {
      display: block;
    }

    .request-banner {
      display: flex;
      align-items: flex-start;
      gap: var(--mat-sys-spacing-16);
      padding: var(--mat-sys-spacing-12) var(--mat-sys-spacing-8) var(--mat-sys-spacing-12) var(--mat-sys-spacing-16);
      border-radius: var(--mat-sys-corner-medium);
      color: var(--mat-sys-on-surface);
      background-color: var(--mat-sys-info-container);
    }

    .request-banner-icon,
    .request-banner-title,
    .request-banner-close {
      color: var(--mat-sys-on-info-container);
    }

    .request-banner-icon {
      padding-top: var(--mat-sys-spacing-4);
    }

    .request-banner-text {
      display: grid;
      flex: 1 1 auto;
      gap: var(--mat-sys-spacing-4);
      min-width: 0;
    }
  `,
})
export class NewCustomerRequestBanner {
  readonly visible = signal(true);
}
